import { AlertCircle, Loader2 } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useCongressMeta } from "@/features/congress-details/api/get-congress";
import { AbstractDetailsForm } from "@/features/congress-details/components/abstract-details-form";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

export function AbstractDetailsPage() {
  const { t } = useTranslation();
  const {
    congress: { id: congressId },
  } = useCongress();
  const {
    data: congress,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useCongressMeta(congressId);
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:flex-col">
      <title>{pageTitle(t("meta.abstractDetails"))}</title>
      <Card className="col-span-12">
        <CardHeader className="font-semibold">
          {t("details.abstractSettings")}
        </CardHeader>
        <CardContent>
          {isLoading && (
            <Loader2 className="absolute right-2 top-[5px] size-6 animate-spin text-primary" />
          )}
          {isError && (
            <Alert variant="destructive">
              <AlertCircle className="size-4" />
              <AlertTitle>{t("common.errorTitle")}</AlertTitle>
              <AlertDescription>{error.message}</AlertDescription>
            </Alert>
          )}
          {isSuccess && <AbstractDetailsForm initialData={congress} />}
        </CardContent>
      </Card>
    </div>
  );
}
